<template>
  <v-container>
    <v-toolbar flat color="white">
      <v-toolbar-title>Administración de editoriales</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="indigo" outline rounded dark class="mb-2" v-on="on">
            <v-icon color="yellow darken-2">add</v-icon>nueva editorial
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="editedItem.nombre" ref="focustxt" label="Nombre editorial"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat small color="error" @click="close">Cancelar</v-btn>
            <v-btn outline color="indigo" @click="save">
              <v-icon color="indigo" style="margin-right:5px;">save</v-icon>Almacenar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="computedHeaders"
      :items="editoriales"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
      :total-items="pagination.totalItems"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td v-if="false">{{ props.item.id }}</td>
        <td>{{ props.item.nombre }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="openDeleteDialog(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Buscar datos de nuevo</v-btn>
      </template>
    </v-data-table>
    <!--DIALOGO DE ELIMINACION !-->
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-text>
          <v-layout justify-space-around>
            <v-icon x-large color="red" style="font-size: 85px;">report</v-icon>
          </v-layout>
        </v-card-text>
        <v-layout justify-space-around>
          <v-card-title class="title text-md-center">¿Estas seguro de querer eliminar este elemento?</v-card-title>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat small color="error" @click="cancelDelete()">No</v-btn>
          <v-btn flat="flat" outline small color="green darken-1" @click="deleteItem()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { debuglog } from "util";
export default {
  data: () => ({
    dialog: false,
    deleteDialog: false,
    search: "",
    headers: [
      {
        text: "Id",
        align: "left",
        sortable: true,
        value: "id",
        hidden: true
      },
      {
        text: "Nombre editorial",
        align: "left",
        sortable: true,
        value: "nombre"
      },
      { text: "Acciones", value: "", sortable: false }
    ],
    editoriales: [],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [10]
    },
    editedIndex: -1,
    editedItem: {
      id: null,
      nombre: ""
    },
    defaultItem: {
      nombre: ""
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva editorial" : "Editar editorial";
    },
    computedHeaders() {
      return this.headers.filter(header => header.text !== "Id");
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    search() {
      this.searchEditoriales(this.search);
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const that = this;
      this.$store
        .dispatch("getEditoriales")
        .then(response => {
          setTimeout(function() {
            that.editoriales = that.$store.getters.editoriales;
            that.pagination = that.$store.state.paginationEditorial;
          }, 200);
        })
        .catch(error => {
          console.log(error);
        });
    },

    editItem(item) {
      this.$refs.focustxt.focus();
      this.editedIndex = this.editoriales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    searchEditoriales(query) {
      const that = this;
      this.$store
        .dispatch("searchEditorial", query)
        .then(response => {
          setTimeout(function() {
            that.editoriales = that.$store.getters.editoriales;
            that.pagination = that.$store.state.paginationEditorial;
          }, 200);
        })
        .catch(error => {
          console.log(error);
        });
    },

    cleanModel() {
      this.editedItem = {
        id: null,
        nombre: ""
      };
      this.defaultItem = {
        nombre: ""
      };
      this.search = "";
    },

    openDeleteDialog(item) {
      this.editedIndex = this.editoriales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.deleteDialog = true;
    },

    deleteItem() {
      const that = this;
      this.$store
        .dispatch("deleteEditorial", this.editedItem)
        .then(response => {
          that.cleanModel();
          that.initialize();
          that.cancelDelete();
        })
        .catch(error => {
          console.log(error);
        });
    },

    cancelDelete() {
      this.deleteDialog = false;
      that.initialize();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      const that = this;
      if (this.editedIndex > -1) {
        this.$store
          .dispatch("updateEditorial", this.editedItem)
          .then(response => {
            that.initialize();
            that.cleanModel();
            that.close();
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.$store
          .dispatch("createEditorial", this.editedItem)
          .then(response => {
            that.cleanModel();
            that.close();
            that.initialize();
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
};
</script>